const otherUser = {
    profile: {}
};

export default otherUser;